export default function (api: GlobalFetch) {
  return async function () {
    const response = await api.fetch(
      `/api/v2/google/status`,
    )
    return await handleResponse(response)
  }
}

export async function handleResponse(response) {
  const json = await response.json()
  return json.items
}

